<script>
    import { onMount } from 'svelte'
    import { fly } from 'svelte/transition'
    import { flyModified } from '../../js/transitions.js'
    import { handleHashChange } from '../../js/hash-scroll.js'
    import PageSection from '../content-types/PageSection.svelte'
    export let page

    onMount(handleHashChange) // init scroll position on mount
</script>

<div
    id="pageContent"
    in:fly={{ y: -20, duration: 1000 }}
    out:flyModified={{ y: 10, duration: 400, position: 'absolute' }}
>
    {#each page.sections as section}
        {#if typeof section.sections !== 'undefined'}
            <PageSection {section} color={page.circuit_color} />
            {#each section.sections as subsection}
                <PageSection section={subsection} sub={true} color={page.circuit_color} />
            {/each}
        {:else}
            <PageSection {section} color={page.circuit_color} />
        {/if}
    {/each}
</div>

<style lang="scss">
    @import "../../styles/vars";

    .section:first-of-type .sectionTitle {
        margin-top: 0;
    }

    #pageContent {
        box-sizing: border-box;
        position: relative;
        width: 50vw;
        margin: 50px 25vw;
        top: 0;
    }

    @include respond-to(phone) {
        #pageContent {
            width: 92vw;
            margin: 50px 4vw;
        }
    }
</style>
